module.exports = __webpack_public_path__ + "img/cd-madrigal-de-craciun.8a7fb875.jpg";